import { Auth } from "aws-amplify";
import { get } from "lodash";

const usePendoInitialization = (companyDetails) => {
  window.pendo.initialize({
    visitor: {
      id: get(Auth, "user.attributes.email", ""),
      role: get(Auth, "user.attributes.custom:role", ""),
      full_name: `${get(
        Auth,
        "user.attributes.custom:firstName",
        ""
      )} ${get(Auth, "user.attributes.custom:lastName", "")}`,
    },
    account: {
      id: get(companyDetails, "tenantId", ""),
      name: get(companyDetails, "name", "")
    },
  });
  return true;
};

export default usePendoInitialization;
